document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(() => {
        const label = document.getElementById('label-md-form__country-code');
        if (label && label.textContent.trim() !== "Select Your Country") {
        label.textContent = "Select Your Country";
        observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});